module.exports = __webpack_public_path__ + "img/SKMA_emergency4.bdf87f22.jpg";